export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Top area */}
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="inline-flex items-center gap-2 text-lg font-bold font-heading text-background-50 whitespace-nowrap">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm font-bold">黑</span>
              黑料
            </a>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              黑料聚合51黑料网、91黑料网、17黑料网及718黑料等热门数字黑料子品牌入口，
              提供51黑料最新地址、17黑料吃瓜视频、718黑料合集，一站浏览数字系列黑料内容。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-telegram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-bold font-heading text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#index" className="block text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">热门索引</a>
              <a href="#carousel" className="block text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">专题合集</a>
              <a href="#ranking" className="block text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">人气榜单</a>
              <a href="#updates" className="block text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">最新动态</a>
            </div>
          </div>

          {/* Brands */}
          <div>
            <h4 className="text-sm font-bold font-heading text-background-50 mb-4">黑料品牌</h4>
            <div className="space-y-2">
              <a href="#" className="block text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">51黑料网</a>
              <a href="#" className="block text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">91黑料网</a>
              <a href="#" className="block text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">17黑料网</a>
              <a href="#" className="block text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">718黑料</a>
            </div>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-sm font-bold font-heading text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400">暂无合作伙伴信息</p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="py-5 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 黑料 - 数字黑料内容聚合导航平台。本站仅为入口导航，不存储任何第三方内容。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#" className="hover:text-background-200 transition-colors cursor-pointer">免责声明</a>
            <a href="#" className="hover:text-background-200 transition-colors cursor-pointer">内容规则</a>
            <a href="#contact" className="hover:text-background-200 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}